import { Metamodel } from 'app/model/base/model';
import { S3StoreReadSettings } from './s3-store-read-settings';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { OracleCloudStorageLinkedService } from 'app/model/linkedservice/oracle-cloud-storage.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.oracleCloudStorage.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(OracleCloudStorageLinkedService)
    }
})

export class OracleCloudStorageStoreReadSettings extends S3StoreReadSettings {
}
